<template>
  <div :class="['tag-type', tagType === 'VIP' ? 'vip-tag' : 'free-tag']" v-if="tagType">
    <i v-if="tagType === 'VIP'" class="fas fa-crown"></i>
    <i v-else class="fas fa-gift"></i>
    <span>{{ tagType }}</span>
  </div>
</template>

<script>
export default {
  name: 'TagTypeComponent',
  props: {
    tagType: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.tag-type {
  background-color: rgba(255, 255, 255, 0.95);
  color: #333;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.tag-type i {
  font-size: 14px;
}

.tag-type.vip-tag {
  background-color: #ff6b6b;
  color: white;
}

.tag-type.vip-tag i {
  color: #ffd700;
}

.tag-type.free-tag {
  background-color: #4ecdc4;
  color: white;
}

.tag-type.free-tag i {
  color: #ffffff;
}
</style>